// This import loads the firebase namespace along with all its type information.
import MobileLoginProxyConfirmation from './mobile-login-proxy-confirmation-model'

export async function load_mobileLoginProxyConfirmations(): Promise<
  MobileLoginProxyConfirmation[]
> {
  throw 'Not implemented'
}

export async function delete_mobileLoginProxyConfirmation(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mobileLoginProxyConfirmation(): Promise<MobileLoginProxyConfirmation> {
  throw 'Not implemented'
}
